import React, { useState, useRef } from 'react';
import Modal from '@cloudscape-design/components/modal';
import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Button from '@cloudscape-design/components/button';
import Container from '@cloudscape-design/components/container';
import Header from '@cloudscape-design/components/header';
import PDFKeywordAnalyzer from './keyword-detection-analyzer';
import keywordAnalyzerIcon from '../assets/keywordAnalyzerIcon.png';
import { addUsage } from './add-usage.js';

const KeywordDetection = () => {
  const [visible, setVisible] = useState(false);
  const [serviceName] = useState('PDF Keyword Analyzer');
  const analyzerRef = useRef();

  const toggleModal = React.useCallback(() => {
    setVisible(true);
  }, []);

  const handleClose = () => {
    // Reset the analyzer when modal is closed
    if (analyzerRef.current) {
      analyzerRef.current.resetAnalysis();
    }
    setVisible(false);
    addUsage('AWESOME PDF TOOLS KeywordDetection', '1.0', 1, window.location.href);
  };

  const handleModalDismiss = () => {
    // Reset the analyzer when modal is dismissed (clicking outside or X button)
    if (analyzerRef.current) {
      analyzerRef.current.resetAnalysis();
    }
    setVisible(false);
    addUsage('AWESOME PDF TOOLS KeywordDetection', '1.0', 1, window.location.href);
  };

  return (
    <div>
      <div className="service-card" onClick={toggleModal}>
        <div className="service-card-icon">
          <img src={keywordAnalyzerIcon} alt="Keyword Detection" loading="lazy" />
        </div>
        <h3 className="service-card-title">Keyword Detection</h3>
        <p className="service-card-desc">Search and analyze keywords in PDF documents</p>
        <div className="service-card-action">
          <span>Get Started</span>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
          </svg>
        </div>
      </div>

      <Modal
        onDismiss={handleModalDismiss}
        visible={visible}
        size="large"
        footer={
          <Box float="right">
            <SpaceBetween direction="horizontal" size="xs">
              <Button variant="link" onClick={handleClose}>
                Close
              </Button>
            </SpaceBetween>
          </Box>
        }
        header={serviceName}
      >
        <PDFKeywordAnalyzer ref={analyzerRef} />
      </Modal>
    </div>
  );
};

export default KeywordDetection;
